import { createSlice, PayloadAction } from "@reduxjs/toolkit";

/**
 * GlobalLoader State Management
 *
 * This slice manages the GlobalLoader component which shows during API calls.
 * It uses an activeRequests counter to handle multiple concurrent requests.
 *
 * IMPORTANT: GlobalLoader and SecureLoader are mutually exclusive.
 * - SecureLoader: session-related operations (validateSession, getSession, terminateSession)
 * - GlobalLoader: all other API calls
 *
 * The loaderMiddleware ensures they never show simultaneously.
 */

interface LoaderState {
  isLoading: boolean;
  activeRequests: number;
  loadingMessage?: string;
}

const initialState: LoaderState = {
  isLoading: false,
  activeRequests: 0,
  loadingMessage: undefined,
};

const loaderSlice = createSlice({
  name: "loader",
  initialState,
  reducers: {
    /**
     * Increment active requests counter and show loader
     */
    showLoader: (state, action: PayloadAction<string | undefined>) => {
      state.activeRequests += 1;
      state.isLoading = true;
      if (action.payload) {
        state.loadingMessage = action.payload;
      }
    },

    /**
     * Decrement active requests counter and hide loader when all complete
     */
    hideLoader: (state) => {
      state.activeRequests = Math.max(0, state.activeRequests - 1);
      // if (state.activeRequests === 0) {
      state.isLoading = false;
      state.loadingMessage = undefined;
      // }
    },

    /**
     * Force reset loader state (used by safety timeout or manual intervention)
     */
    resetLoader: (state) => {
      state.isLoading = false;
      state.activeRequests = 0;
      state.loadingMessage = undefined;
    },
  },
});

export const { showLoader, hideLoader, resetLoader } = loaderSlice.actions;
export default loaderSlice.reducer;
